export class MagazineCategoryParser {
    constructor(categoryList) {
        this.categoryList = categoryList
    }


    getCategoryListParsed() {
        return createCategoryChildren(this.categoryList);
    }

    getCategoryListInlineParser() {
        return createCategoryInlineChildren(this.categoryList)
    }
}

function createCategoryChildren(categoryList) {
    const _category = []
    categoryList.map((item, index) => {
        let categoryItem

        if (item.children && item.children.length > 0) {
            categoryItem = {
                id: item.id,
                name: item.title,
                parentId: item.parent && item.parent.id ? item.parent.id : -1,
                subCategory: createCategoryChildren(item.children)
            }
        } else {
            categoryItem = {
                id: item.id,
                name: item.title,
                parentId: item.parent && item.parent.id ? item.parent.id : -1,
            }
        }

        _category.push(categoryItem)
    })


    return _category
}

function createCategoryInlineChildren(categoryList, parentName = "") {
    const _category = []

    categoryList.map((item) => {
        _category.push({
            id: item.id,
            name: `${parentName}${item.title}`,
        })

        if (item.children && item.children.length > 0) {
            _category.push(
                ...createCategoryInlineChildren(item.children, `${parentName}${item.title}/`)
            )
        }
    })


    return _category
}